module.exports = __webpack_public_path__ + "static/assets/19b5a493d1a785015a37a1af772b5b3d.png";